import { render } from "./termsAndPrivacyComponent.vue?vue&type=template&id=0aa32080"
import script from "./termsAndPrivacyComponent.vue?vue&type=script&lang=js"
export * from "./termsAndPrivacyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__